import { RefObject, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useAppSelector } from 'flow/hooks/useRedux';
import { getIsSinglePaneMode } from 'flow/selectors/selectors';
import { routes } from 'flow/types/routes';

// Opening a card in the narrow layout hides the focused row, so focus is
// usually on the body when Escape is pressed. Keys from other controls, such
// as the profile picker or a dialog, are left alone.
const useEscapeReturnsToContactList = (cardRef: RefObject<HTMLElement>) => {
    const history = useHistory();
    const isSinglePaneMode = useAppSelector(getIsSinglePaneMode);

    useEffect(() => {
        if (!isSinglePaneMode) {
            return undefined;
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            const target = event.target as Node;
            if (
                event.key !== 'Escape' ||
                event.defaultPrevented ||
                (target !== document.body && !cardRef.current?.contains(target))
            ) {
                return;
            }
            history.replace(routes['extensions']);
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [cardRef, history, isSinglePaneMode]);
};

export default useEscapeReturnsToContactList;
